export default {
  learnMore: {
    id: 'payment_advertisement_learn_more',
    defaultMessage: 'Learn more',
  },
  payInInstallments: {
    id: 'payment_advertising_pay_in_installments',
    defaultMessage: 'Pay in installments',
  },
}
